<template>
  <b-button
    class="pr-4 pl-4"
    :style="{background: color ? color : ''}"
    :variant="color ? null : variant"
    :size="size"
    :disabled="disabledButton"
    @click="$emit('click')">
    <icon-svg v-if="icon" 
              :icon="icon.type"
              class="mr-2"
              :style="{width: icon.size, fill: icon.color}"
              :class="icon.size + ' ' + icon.color" />
    <span :style="colorText && {color: colorText}">{{ text }}</span>    
    <slot />
  </b-button>
</template>

<script>
  export default {
    name: 'CustomButton',
    props: {
      variant: {
        type: String,
        default: "primary"
      },
      color: {
        type: String,
        default: ''
      },
      colorText: {
        type: String,
        default: ''
      },
      size: {
        type: String,
        default: "md"
      },
      text: {
        type: String,
        default: "" 
      },
      disabledButton: {
        type: Boolean,
        default: false
      },
      icon: {
        type: [Boolean, () => {}],
        default: false 
      }
    }
  }
</script>
